<template>
  <v-row v-if="careerHistories && careerHistories.length">
    <v-col xs="12" sm="12" lg="6" v-for="(item, index) in careerHistories" :key="'row_' + index">
      <CareerHistoryItem :careerHistory="item" @edit="edit(item)" @remove="remove(item)" :details="details" :skills="skills" />
    </v-col>
  </v-row>
</template>
<script lang="ts">
import CareerHistories from "../../../models/CareerHistories";
import { defineComponent } from "vue";
import moment from "moment";
import CareerHistoryItem from "./CareerHistoryItem.vue";
export default defineComponent({
  props: ["skills", "details", "careerHistoryList", "isHiringmanager"],
  components: { CareerHistoryItem },
  data() {
    return {
      careerHistories: [] as CareerHistories[],
    };
  },
  methods: {
    getDetailsName(ids: string[]) {
      const names: string[] = [];
      if (ids) {
        ids.forEach((item: any) => {
          names.push(this.getDetailName(item));
        });
      }
      return names.join("-");
    },
    getDetailName(id: string) {
      return this.details.find((item: any) => item.id == id)?.Name ?? id;
    },
    getSkillName(skillId: any) {
      var findSkill = this.skills.find((s: any) => s.id === skillId);
      if (findSkill) {
        return findSkill.Text;
      }
    },
    edit(item: any) {
      this.$emit("edit", item);
    },
    remove(item: any) {
      this.$emit("remove", item);
    },
    formatDate(date: Date): string {
      return moment(date).format("YYYY-MM");
    },
  },
  watch: {
    careerHistoryList(newVal) {
      this.careerHistories = newVal;
    },
  },

  mounted() {
    this.careerHistories = [...this.careerHistoryList];
  },
});
</script>
